const ENGINE_MODES = Object.freeze({
  "ALL": 'ALL',
  "STOP": 'STOP',
  "ON_MOVEMENT": 'ONMOV',
});

export default Object.freeze({
    ENGINE: ENGINE_MODES
});